import useTrustedEmailSender, {
  trustedEmailSenderState
} from 'Hooks/useTrustedEmailSender/useTrustedEmailSender'
import { evalCondition } from 'mailup-react-helpers'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

import {
  Flex,
  FormElement,
  IconLock,
  InputText,
  TrustedEmailInput
} from 'mailup-web-components'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const InputSenderEmail = () => {
  const intl = useIntl()
  const [{ step2 }, setAbTestState] = useRecoilState(abTestState)
  const setTrustedEmailState = useSetRecoilState(
    trustedEmailSenderState('trustedSender')
  )

  const trustedSenderProps = useTrustedEmailSender(
    'trustedSender',
    step2.senderInfo.senderEmail,
    true
  )

  const isWL = evalCondition('co:WHITELABEL')

  useEffect(() => {
    if (!step2.senderInfo.fetchedSender && !step2.senderInfo.isPEC) {
      setTrustedEmailState(prev => ({
        ...prev,
        value: step2.senderInfo.senderEmail || undefined
      }))

      setAbTestState(prev => ({
        ...prev,
        step2: {
          ...prev.step2,
          step2IsDirty: true,
          senderInfo: {
            ...prev.step2.senderInfo,
            fetchedSender: true
          }
        }
      }))
    }
  }, [
    step2.senderInfo.fetchedSender,
    step2.senderInfo.senderEmail,
    step2.senderInfo.isPEC
  ])

  useEffect(() => {
    step2.senderInfo.fetchedSender &&
      setAbTestState(prev => ({
        ...prev,
        step2: {
          ...prev.step2,
          step2IsDirty: true,
          senderInfo: {
            ...prev.step2.senderInfo,
            senderEmail: trustedSenderProps.value
          }
        }
      }))
  }, [trustedSenderProps.value])

  return (
    <div>
      {step2.senderInfo.isPEC ? (
        <>
          <FormElement
            required
            label={intl.formatMessage({ id: 'Load.Common.SenderEmailLabel' })}
            labelHelp={intl.formatMessage({
              id: 'Load.PecPlus.AltImgMailMittPec'
            })}
          >
            <div
              data-tip={intl.formatMessage({
                id: isWL
                  ? 'Load.PecPlus.senderPecTooltipWL'
                  : 'Load.PecPlus.senderPecTooltip'
              })}
            >
              <Flex className='pec__input-container'>
                <IconLock className='icon' />
                <InputText
                  placeholder={step2.senderInfo.senderEmail}
                  disabled
                />
              </Flex>
            </div>
          </FormElement>
        </>
      ) : (
        <>
          <FormElement
            required
            label={
              step2.senderInfo.customSender
                ? intl.formatMessage({
                    id: 'Load.EmailSendingWizard.DefaultSenderEmailLabel'
                  })
                : intl.formatMessage({
                    id: 'Load.Common.SenderEmailLabel'
                  })
            }
            labelHelp={intl.formatMessage({
              id: 'Load.Common.SenderEmailTooltip'
            })}
          >
            <div data-mu-test='sending-wizard-input-sender-email'>
              <TrustedEmailInput
                id='trustedSender'
                disabled={evalCondition('uo:EMAILSENDERLOCKED')}
                {...trustedSenderProps}
              />
            </div>
          </FormElement>
        </>
      )}
    </div>
  )
}

export default InputSenderEmail
